// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionChoiceTagging_container__gGZPV","selectorsContainer":"QuestionChoiceTagging_selectorsContainer__3LKfI","answer":"QuestionChoiceTagging_answer__LWuH5"};